const ADD_USER_TYPES = Object.freeze({
  MANUALLY: 'manually',
  BULK: 'bulk',
  INVITE: 'invite',
})

export { ADD_USER_TYPES }
